module.exports = __webpack_public_path__ + "media/images/webclip-6baa8553aed5d33c7ce82324e82a8703.png";